import { getRandomArrayElement } from '../util/getRandomArrayElement';

const createParameter = ({
   exerciseParameterConfig,
   randomize,
   defaultValue,
   bipolar,
   range,
}) => {
   const parameter = {
      value: defaultValue,
      disabled:
         exerciseParameterConfig == null ||
         exerciseParameterConfig.test === false,
   };

   if (!exerciseParameterConfig) {
      return parameter;
   }

   if (exerciseParameterConfig.incrementCount) {
      parameter.incrementCount = exerciseParameterConfig.incrementCount;
   }

   if (exerciseParameterConfig.enabledOptions) {
      parameter.enabledOptions = exerciseParameterConfig.enabledOptions;
   }

   // ensure value is close to default value but also valid based on increment count
   if (
      parameter.incrementCount &&
      !randomize &&
      exerciseParameterConfig.useValue == null
   ) {
      // 10 is arbitrary but larger than the max possible difference
      let diff = 10;
      let value;

      for (
         let i = bipolar ? -1 * parameter.incrementCount : 0;
         i <= parameter.incrementCount;
         i += 1
      ) {
         const newVal = i / parameter.incrementCount;
         const newDiff = Math.abs(defaultValue - newVal);
         if (newDiff < diff) {
            diff = newDiff;
            value = newVal;
         }
      }

      parameter.value = value;
   }

   if (!randomize) {
      return parameter;
   }

   // new approach for increments: ... fill array with possible values 0-1 or -1-1; filter those that are out of range; then random array element
   // also filter those that are out of range for selected sample... in future

   // get the range
   //
   const defaultRange = [bipolar ? -1 : 0, 1];
   const rangeLow = Math.max(
      range?.[0] ?? defaultRange[0],
      exerciseParameterConfig.range?.[0] ?? defaultRange[0]
   );
   const rangeHigh = Math.min(
      range?.[1] ?? defaultRange[1],
      exerciseParameterConfig.range?.[1] ?? defaultRange[1]
   );

   if (exerciseParameterConfig.useValue != null) {
      parameter.value = exerciseParameterConfig.useValue;
   } else if (parameter.enabledOptions) {
      parameter.value = getRandomArrayElement(parameter.enabledOptions);
   } else if (parameter.incrementCount == null) {
      parameter.value = Math.random() * (rangeHigh - rangeLow) + rangeLow;
   } else {
      const possibleValues = [];
      for (
         let i = bipolar ? -1 * parameter.incrementCount : 0;
         i <= parameter.incrementCount;
         i += 1
      ) {
         possibleValues.push(i / parameter.incrementCount);
      }
      parameter.value = getRandomArrayElement(
         possibleValues.filter(
            (value) =>
               value >= rangeLow &&
               value <= rangeHigh &&
               !(value === 0 && exerciseParameterConfig.excludeZero)
         )
      );
   }

   return parameter;
};

export { createParameter };
